export const auth = {
	LOGIN: "auth/login",
	LOGOUT: "auth/logout",
}

export default auth
